import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { FullscreenFallback } from "../DialogComponents/DialogFallback/FullscreenFallback";
import { styledHeaderText } from "../styled";

export const CopyResource: FC = () => {
  const { t } = useTranslation("common");

  return (
    <FullscreenFallback
      context={{
        title: {
          text: styledHeaderText(`${t("actions.copy")}...`),
          icon: "copy",
        },
      }}
    />
  );
};
